import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FlaskConical, X } from "lucide-react";

/** Aviso na lista de cursos para quem tem o Tricolab liberado e ainda não cadastrou nenhuma cliente. Some ao fechar ou ao começar a usar. */
const chave = (id) => `iep-aviso-tricolab-${id}`;
const lerVisto = (id) => { try { return localStorage.getItem(chave(id)) === "1"; } catch { return false; } };
const marcarVisto = (id) => { try { localStorage.setItem(chave(id), "1"); } catch { /* sem armazenamento: o aviso volta na próxima visita */ } };

export function NovidadeTricolab() {
  const { user } = useAuth();
  const [mostrar, setMostrar] = useState(false);
  useEffect(() => {
    setMostrar(false);
    if (!user?.tricolab || user.role === "admin" || lerVisto(user.id)) return;
    let vivo = true;
    api.get("/tricolab/status").then((r) => { if (vivo && !r.data.clientes) setMostrar(true); }).catch(() => {});
    return () => { vivo = false; };
  }, [user?.id, user?.tricolab, user?.role]);
  if (!mostrar) return null;
  const fechar = () => { marcarVisto(user.id); setMostrar(false); };
  return (
    <div className="max-w-6xl mx-auto w-full px-5 md:px-8 pt-5">
      <div className="relative rounded-2xl p-5 text-white flex flex-wrap items-center gap-4 shadow-lg" style={{ background: "linear-gradient(135deg,#0f1f1a,#1d3a31 60%,#2f8f63)" }} data-testid="tricolab-novidade">
        <span className="h-12 w-12 rounded-xl bg-[#e4f1ea] grid place-items-center shrink-0"><FlaskConical className="h-6 w-6 text-[#0f1f1a]" /></span>
        <div className="flex-1 min-w-[220px] pr-6">
          <div className="text-[11px] font-bold uppercase tracking-wider text-green-200">Novidade · liberado para você</div>
          <div className="font-display text-lg font-bold">Seu app Tricolab<sup className="text-[10px]">®</sup> já está pronto</div>
          <p className="text-sm text-white/80">Faça o check-up capilar das suas clientes no celular: cadastro, testes, fórmula e o relatório para enviar à cliente.</p>
        </div>
        <a href="/tricolab" target="_blank" rel="noopener" onClick={fechar} className="inline-flex items-center rounded-md bg-white px-4 py-2 text-sm font-bold text-[#0f1f1a] hover:bg-slate-100">Abrir o Tricolab</a>
        <button onClick={fechar} className="absolute top-2 right-2 rounded-full p-1 text-white/70 hover:bg-white/15" aria-label="Fechar aviso"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
